import { useToastStore } from '@/store/apps/toastStore';

import generateUniqueId from '@/utils/generateUniqueId';

import Toast from '@/components/shared/ui/toasts/Toast';
import type { ToastType } from '@/components/shared/ui/toasts/types';

export default function useToast() {
  const { openToast } = useToastStore();

  const showToast = ({
    state,
    message,
    onClose,
  }: {
    state: ToastType['state'];
    message: string;
    onClose?: () => void;
  }) => {
    openToast({
      id: generateUniqueId('toast'),
      component: Toast,
      state,
      message,
      onClose,
    });
  };

  return { showToast };
}
